import { render, staticRenderFns } from "./PolandStats.vue?vue&type=template&id=18de8693&scoped=true&"
import script from "./PolandStats.vue?vue&type=script&lang=js&"
export * from "./PolandStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de8693",
  null
  
)

export default component.exports